import React, { Component } from 'react'
import StixToast from '@softwaredev_cegeka/stix-core/dist/components/Toast'
import { notifierStore } from '../../stores'
import { Observer } from 'mobx-react'

/**
 * Displays toasts as notifier element. Toast are based on the ones from the
 * Stix core library
 */
class Toast extends Component {
    closeToast = () => {
        notifierStore.setShowMessage(false)
    }

    render() {
        const { variant, children, title } = this.props

        return (
            <Observer>
                {() => {
                    return (
                        <StixToast
                            variant={variant}
                            show={notifierStore.showMessage}
                            onClose={this.closeToast}
                        >
                            <StixToast.Header>{title}</StixToast.Header>
                            {children ? (
                                <StixToast.Body>{children}</StixToast.Body>
                            ) : null}
                        </StixToast>
                    )
                }}
            </Observer>
        )
    }
}

/**
 * Class for displaying help and error messages.
 */
class Notifier extends Component {
    static Toast = Toast

    render() {
        return (
            <StixToast.Container position={'fixed'}>
                {this.props.children}
            </StixToast.Container>
        )
    }
}

export default Notifier
